// extracted by mini-css-extract-plugin
export default {"ace-c-contract-partner-item--is-selected":"contract-partner-item--is-selected---35b27a83"};